import { ReactElement, ReactNode } from "react"
import { Navigate } from "react-router-dom"
import PageLoader from "../../components/PageLoader"
import { privateRedirectPath } from "../../constants/routes"
import useAuth from "../../hooks/useAuth"

type Props = {
  children: ReactNode
}

export default function AuthWrapper({ children }: Props): ReactElement {
  const { user, onFirstLoad } = useAuth()

  return (
    <>
      {onFirstLoad
        ? <PageLoader className="h-screen w-screen top-0 left-0 fixed"/>
        : user
          ? <Navigate to={privateRedirectPath} replace/>
          : children
      }
    </>
  )
}
